import moment                               from "moment"
import React, { Component,Fragment }        from "react"
import { Row, Col, Table }          from "elemental-react16"
import { Icon, Image,Button, Message }                      from "semantic-ui-react"
import { Link }                             from "react-router-dom"
import shop                                 from "shop/shop"
import { checkCartSize, checkMinCartValue } from "pages/checkout/check"
import swal                                 from "sweetalert"
import "style/CheckoutPage.scss"
import productStore                         from "stores/productStore"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import _                                    from "lodash"
import Responsive from "react-responsive"
import paypalLogo      from "assets/de-pp-logo-200px.png"
import { formatPrice } from "../../../../components/Price/Price";

export default class ReturnPageSuccess extends Component {
  
  state = {
    loading: true,
    bill: false,
    byId: {}
  }
  
  componentDidMount() {
    
    let ok = checkCartSize()
    ok = ok && checkMinCartValue()
    
    if ( !ok ) {
      this.props.history.replace( "/return" )
      return
    }
    
    window.setTimeout( this.submit, 5000 + shop.cart.size * 25 )
  }
  
  submit = () => {
    
    // setup manually
    const extras = {
      delivery_address_id: shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid,
      manual_order_id: shop.cart.getExtra( "manual_order_id" ),
      referenceId: shop.cart.getExtra( "referenceId" ),
      is_quotation_request: shop.cart.getExtra( "is_quotation_request" ),
      attachments: shop.cart.getExtra( "attachments" ),
      "ts-ordertype": shop.cart.getExtra( "is_quotation_request" ) ? "offer" : null,
      "print_receipt": shop.cart.getExtra( "print_receipt" ),
      "kartons_all": shop.cart.getExtra( "kartons_all" ),
      "seasonName": shop.cart.getExtra( "seasonName" ),
      "seasonID": shop.cart.getExtra( "seasonID" ),
    }
    
    // merge all data
    _.map( shop.cart.data.extras, ( value, key ) => {
      if ( !extras[ key ] ) extras[ key ] = value
    } )
    
    shop.cart.submit( {
                        extras
                      } )
        .then( ( bill ) => {
          this.setState( { bill, loading: false } )
          shop.cart.productsById.clear()
          shop.cart.clear()
          shop.cart.update()
      
          let p = bill.positions.map( position => {
            console.log( "loading", position )
            position.count = position.count-1
            return productStore.get( position.article_id )
          } )
          return Promise.all( p )
        } )
        .then( products => {
          let byId = {}
          products.forEach( product => {
            byId[ product.map_id ] = product
          } )
      
          this.setState( { byId } )
        } )
        .catch( error => {
          console.error( "Checkout Error:", error )
          let errorMessageCreated = false
          try {
            const errComplex = JSON.parse( error.message )
            if ( errComplex.addsum && errComplex.rulename === "Budget" ) {
              swal( translate( "Fehler – Budgetüberschreitung" ), `${translate("BUDGET_ERROR", {value: formatPrice(errComplex.addsum-errComplex.maxvalue)})}`, "error" )
            } else {
              swal( translate( "Error" ), error, "error" )
            }
            errorMessageCreated = true
          }
          catch (err) {
            console.error( "ERROR IN CHECKOUT", err )
          }
          if ( !errorMessageCreated ) {
            swal( translate( "Error" ), error, "error" )
          }
          this.props.history.replace( "/return" )
          this.setState( { error } )
        } )
  }
  
  render() {
    const { bill, byId, loading } = this.state

    if ( loading ) {
      return <div className="pa4 pt7 tc">
        <Spinner size="md" type="inverted"/></div>
    }

    
    return <Page bill={bill} byId={byId}/>
  }
}

const Page = ( { bill, byId } ) => {
  if ( !bill ) return null
  console.log("extras", bill)
  const handleGeneratePDF = () => {
    console.log("GENERATE PDF", shop.config.API, shop.session.shopuser.customer, bill.extras, shop.session.value, bill.extras.seasonName, bill.extras.seasonID);
    shop.toast("Ihre PDF wird generiert.");
    
    fetch(`${shop.config.API}reports/create?template=PaketBarcodes`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
            customer: shop.session.shopuser.customer,
            count: bill.extras.kartons_all,
            address: shop.session.value, 
            season: bill.extras.seasonName,
            seasonID: bill.extras.seasonID,
            totalPackages: bill.extras.totalKartons,
            orderDate: bill.register
        } )
    })
    .then(response => {
        response.json().then(data => {
            console.log("RESPONSE DATA: ", data);
            const rid = data.rid;
            fetch(`${shop.config.API}reports/load/pakete.pdf?rid=${rid}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/pdf"
                }
            })
            .then(responsePDF => responsePDF.blob())
            .then(blob => {
                console.log("BLOB: ", blob);
                const url = URL.createObjectURL(blob);
                console.log("URL: ", url);
                window.open(url, "_blank");
            })
            .catch(error => {
                shop.toast("Fehler beim anzeigen der PDF.");
                // Handle the error
            });
        }).catch(error => {
            shop.toast("Fehler beim Verarbeiten der Antwort.");
            // Handle the error
        });
    })
    .catch(error => {
        shop.toast("Fehler beim generieren der PDF.");
        // Handle the error
    });
}
  const order = bill
  //console.log("RETURN ORDER", order)
  const isOffer = order.extras[ "ts-ordertype" ] === "offer"

  const handleDPD = () => {
    shop.toast( "DPD Retourenschein wird heruntergeladen" )
  }
  console.log("ORDER", order)
  return (
    <Fragment>
      <Responsive minWidth={790}>
        <div className="ui container mw9 ph3 center pt4">
        <section className="billing-tab">
          {/*<img alt={"Firmenlogo"} width={235} className="pt2 pb4" src={shop.config.logo}/>*/}
          <Image src={"/BH_logo_lang.svg"} alt="Firmenlogo"  width={235}/>
          <h1 className="tl ttu b pb2">{translate( "Vorläufige Retourenbestätigung" )} {isOffer && "Ihrer Anfrage"}</h1>
          {shop.session.contact &&
            <h2 className="intro-line">
              {isOffer ?
                <span>{translate( "confirmation.thanks_request_anonymous" )}</span>
                : <span>{translate( "confirmation.thanks_order_anonymous" )}</span>}
            </h2>}
          
          {isOffer ?
            <p className="pb2 bb b--black-20">Ihre Anfrage ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>
            : <p className="pb2 bb b--black-20">Ihre Retourenerfassung ist bei uns eingegangen und wird schnellsmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst.</p>
          }
          {/*<p>Ihre Bestellung ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>*/}
        </section>
        
        <section className="billing-tab pt4">
          <div>
          <Message className="ui negative message">
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Pakete ohne Barcodes werden nicht gutgeschrieben.")}</div>
                            </Message>
          </div>
          <Table>
          <colgroup>
            </colgroup>
            <tbody>
              <tr>
                <td>
                <div className="pa2">
                <b>1. Drucken Sie die erzeugte PDF aus.</b>
            </div>
            <div className="pa3 bb b--black-20  ">
            <Button size="huge" 
                            onClick={handleGeneratePDF} primary>PDF anzeigen und drucken</Button>

                
            </div>
            <div className="pb4 pt4 ">
                            <b>2. Legen Sie jeweils einen Barcode in ein Paket. Verschließen Sie den Karton transportsicher (z.B. mit Stretchfolie).</b> 
                            <br/>
                            <img className="pa3" src="/beispiel.png" style={{width: "300px", height:"190px", paddingTop: "15px"}} alt="Beispiel" />
                            </div>
                </td>
                {/*<td>
                {<img className="pb2 pt3" src={"/EDEKA_Ostern_2024_NEU.jpg"}  centered/>}
                </td>*/}
              </tr>
            </tbody>
          </Table>
        
          <h4>{translate( "your data" )}</h4>
          <Table className="billing-overview-table">
            
            <colgroup>
              <col width="25%"/>
              <col width="75%"/>
            </colgroup>
            
            <tbody>

            {shop.config.checkoutFeatures.orderNumber && <tr>
              <td>{translate( "Order Id" )}</td>
              <td className="overview-value">{order.handid}</td>
            </tr>
            }
                      
            {order.extras.manual_order_id &&
              <tr>
                <td>{translate( "manual_order_id" )}</td>
                <td className="overview-value">{order.extras.manual_order_id}</td>
              </tr>
            }
            {order.extras.manual_order_id &&
              <tr>
                <td>{translate( "Referenznummer" )}</td>
                <td className="overview-value">{order.extras.referenceId}</td>
              </tr>
            }
            
            {shop.config.checkoutFeatures.orderDate &&
              <tr>
                <td>{translate( "Bestellzeitpunkt" )}</td>
                <td className="overview-value">{moment( order.created ).format( "HH:mm [Uhr], DD.MMM YYYY" )}</td>
              </tr>
            }
            
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            
            <tr>
              <td>{translate( "GLN / ILN-Nummer" )}</td>
              <td className="overview-value">{order.customerid}</td>
            </tr>
            <tr>
              <td>{translate( "Referenznummer" )}</td>
              <td className="overview-value">{order.extras.referenceId}</td>
            </tr>
            <tr>
              <td>{translate( "Saison" )}</td>
              <td className="overview-value">{order.extras.seasonName}</td>
            </tr>

            
            </tbody>
          </Table>
        </section>
        
        <section className="billing-tab pt4">
          <Row>
            <Col sm="1/2">
              <h4>{translate( "Marktadresse" )}</h4>
              <p>
                {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                {order.bill.street} <br/>
                {order.bill.pcode} {order.bill.city} <br/>
                {order.bill.country}
              </p>
            </Col>
            
            {/*<Col sm="1/2">
              <h4>{translate( "Lieferadresse" )}</h4>
              {order.deliver.name ? <p>
                {order.deliver.name1} {order.deliver.name2} {order.deliver.name3} <br/>
                {order.deliver.street} <br/>
                {order.deliver.pcode} {order.deliver.city} <br/>
                {order.deliver.country}
              </p> : <p>
                {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                {order.bill.street} <br/>
                {order.bill.pcode} {order.bill.city} <br/>
                {order.bill.country}
              </p>}
              </Col>*/}
          </Row>
        </section>

        {/*<section className="billing-tab pt4">
          <Button primary onClick={handleDPD}>
              DPD Retourenschein herunterladen
          </Button>
        </section>*/}
        
        <section className="billing-tab pt4">
          <h2>{isOffer ? <span>{translate( "Ihre Anfrage" )}</span> : <span>{translate( "Ihre angemeldeten Paketdaten" )}</span>}</h2>
          
          <SuccessTable showTax={order.extras.payment} positions={order.positions} byId={byId} netto={order.netto} currency={order.currency}/>
          
          {/*<div className="tr">
            Alle Preise zzgl. MwSt (19%)
              </div>*/}
          
          {order.extras.payment && <div>
            <h3 className={"mt4"}>{translate( "Zahlung" )}</h3>
            <div><Image src={paypalLogo}/></div>
          </div>}
          
          {order.customer.extras.zahlung && <div>
            <h3 className="mt4">{translate( "Zahlungsweise" )}</h3>
            <p>{order.customer.extras.zahlung}</p>
          </div>}
          
          {/*<h3 className="mt4">{translate( "your comment" )}</h3>
          <p>{order.comment}</p>*/}
          
          {order.deliverdate && <div>
            <h3 className="mt4">{translate( "Liefertermin (Wunsch)" )}</h3>
            <p>{moment( moment( order.deliverdate ), "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</p>
          </div>}
          
          
          {order.extras.attachments && <div>
            <h3 className="mt4">Ihr Anhang</h3>
            <p>{order.extras.attachments}</p>
          </div>}
          
          {order.extras.print_receipt && <div>
            <h3 className="mt4">{translate( "Belegausdruck/Innendienst" )}</h3>
            <p>{order.extras.print_receipt}</p>
          </div>}
          
          {/*!order.extras.payment && <div className="mt4">
            <p className="b"> {translate( "confirmation.notice" )}</p>
            <p>Der Gesamtpreis netto kann sich bei der Rechnungsstellung durch Rabatte noch ändern.</p>
          </div>*/}
        </section>
        
        {shop.config.checkout_thank_you && <div className="pv4">
          <div style={{ whiteSpace: "pre-line" }}>{window.translate( "checkout_thank_you" )}</div>
        </div>}
        
        <section className="text-left pt3 tc">
          <Link to="/return"> <Button type="primary"> <Icon name="chevron left"/>{translate( "zurück zur Retourenerfassung" )}</Button> </Link>
        </section>
        <br/>
      </div>
      </Responsive>
      <Responsive maxWidth={789}>
      <div className="ui container mw9 ph3 center pt4">
        <section className="billing-tab">
          <div className="tc">
          {/*<img alt={"Firmenlogo"} width={235} className="pt2 pb4" src={shop.config.logo}/>*/}
          <Image src={"/BH_logo_lang.svg"} alt="Firmenlogo"  width={235}/>
          </div>
          <h1 className="tc ttu b pb2">{translate( "Vorläufige Retourenbestätigung" )} {isOffer && "Ihrer Anfrage"}</h1>
          {shop.session.contact &&
            <h2 className="intro-line">
              {isOffer ?
                <span>{translate( "confirmation.thanks_request_anonymous" )}</span>
                : <span>{translate( "confirmation.thanks_order_anonymous" )}</span>}
            </h2>}
          
          {isOffer ?
            <p className="pb2 tc bb b--black-20">Ihre Anfrage ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>
            : <p className="pb2 bb b--black-20">Ihre Retourenerfassung ist bei uns eingegangen und wird schnellsmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst.</p>
          }
          {/*<p>Ihre Bestellung ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>*/}
        </section>

        <section className="billing-tab pt4 pb2">
        <div className="pt2 pb2 tc">
        <Message className="ui negative message">
                                <div className="f4 fw7"><Icon className="warning circle"></Icon>
                                {translate( "Pakete ohne Barcodes werden nicht gutgeschrieben.")}</div>
                            </Message>
         </div>
        <div className="tc pa2 bb b--black-20  ">
                <b>1. Drucken Sie die erzeugte PDF aus.</b>
            </div>
            <div className="pa3 bb b--black-20  ">
                <table>
                    <tr>
                        <td className="tc">
                        <Button size="huge" 
                            onClick={handleGeneratePDF} primary>PDF anzeigen und drucken</Button>
                        </td>
                    </tr>
                </table>

                
            </div>
            <div className="pb4 pt4 tc">
                            <b>2. Legen Sie jeweils einen Barcode in ein Paket. Verschließen Sie den Karton transportsicher (z.B. mit Stretchfolie).</b> 
                            <br/>
                            <img src="/beispiel.png" style={{width: "300px", height:"190px"}} centered alt="Beispiel" />
                            </div>
          <h4 className="tc">{translate( "your data" )}</h4>
          <Table className="billing-overview-table">
            
            <colgroup>
              <col width="25%"/>
              <col width="75%"/>
            </colgroup>
            
            <tbody>
            {shop.config.checkoutFeatures.orderNumber && <tr>
              <td>{translate( "Order Id" )}</td>
              <td className="overview-value">{order.handid}</td>
            </tr>
            }
                      
            {order.extras.manual_order_id &&
              <tr>
                <td>{translate( "manual_order_id" )}</td>
                <td className="overview-value">{order.extras.referenceId}</td>
              </tr>
            }
            {order.extras.referenceId &&
              <tr>
                <td>{translate( "Referenznummer" )}</td>
                <td className="overview-value">{order.extras.manual_order_id}</td>
              </tr>
            }
            
            {shop.config.checkoutFeatures.orderDate &&
              <tr>
                <td>{translate( "Bestellzeitpunkt" )}</td>
                <td className="overview-value">{moment( order.created ).format( "HH:mm [Uhr], DD.MMM YYYY" )}</td>
              </tr>
            }
            
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            
            <tr>
              <td>{translate( "GLN / ILN:" )}</td>
              <td className="overview-value tr">{order.customerid}</td>
            </tr>
            <tr>
              <td>{translate( "Referenznummer" )}</td>
              <td className="overview-value tr">{order.extras.referenceId}</td>
            </tr>
            <tr>
              <td>{translate( "Saison" )}</td>
              <td className="overview-value tr">{order.extras.seasonName}</td>
            </tr>

            
            </tbody>
          </Table>
        </section>
        
        <section className="billing-tab pt1 bt b--black-10">
          <Row>
            {/*<Col sm="1/2">
            <h4>{translate( "Marktadresse" )}</h4>
            </Col>
            <Col sm="2/2">
              <p>
                {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                {order.bill.street} <br/>
                {order.bill.pcode} {order.bill.city} <br/>
                {order.bill.country}
              </p>
          </Col>*/}
            <table>
              <colgroup>
                <col width="25%"/>
                <col width="75%"/>
              </colgroup>
              <tbody>
                <tr>
                  <td className="tl fw7">{translate( "Marktadresse:" )}<br/><br/><br/></td>
                  <td className="tr">
                    {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                    {order.bill.street} <br/>
                    {order.bill.pcode} {order.bill.city} <br/>
                    {order.bill.country}
                  </td>
                </tr>
              </tbody>
            </table>
            
            {/*<Col sm="1/2">
              <h4>{translate( "Lieferadresse" )}</h4>
              {order.deliver.name ? <p>
                {order.deliver.name1} {order.deliver.name2} {order.deliver.name3} <br/>
                {order.deliver.street} <br/>
                {order.deliver.pcode} {order.deliver.city} <br/>
                {order.deliver.country}
              </p> : <p>
                {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                {order.bill.street} <br/>
                {order.bill.pcode} {order.bill.city} <br/>
                {order.bill.country}
              </p>}
              </Col>*/}
          </Row>
        </section>
        
        {/*<section className="billing-tab pt4">
          <Button primary onClick={handleDPD}>
              DPD Retourenschein herunterladen
          </Button>
        </section>*/}

        <section className="billing-tab pt4">
          <h2 className="tc">{isOffer ? <span>{translate( "Ihre Anfrage" )}</span> : <span>{translate( "Ihre angemeldeten Paketdaten" )}</span>}</h2>
         
          <SuccessTable showTax={order.extras.payment} positions={order.positions} byId={byId} netto={order.netto} currency={order.currency}/>
          
          {/*<div className="tr">
            Alle Preise zzgl. MwSt (19%)
              </div>*/}
          
          {order.extras.payment && <div>
            <h3 className={"mt4"}>{translate( "Zahlung" )}</h3>
            <div><Image src={paypalLogo}/></div>
          </div>}
          
          {order.customer.extras.zahlung && <div>
            <h3 className="mt4">{translate( "Zahlungsweise" )}</h3>
            <p>{order.customer.extras.zahlung}</p>
          </div>}
          
          {/*<h3 className="mt4">{translate( "your comment" )}</h3>
          <p>{order.comment}</p>*/}
          
          {order.deliverdate && <div>
            <h3 className="mt4">{translate( "Liefertermin (Wunsch)" )}</h3>
            <p>{moment( moment( order.deliverdate ), "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</p>
          </div>}
          
          
          {order.extras.attachments && <div>
            <h3 className="mt4">Ihr Anhang</h3>
            <p>{order.extras.attachments}</p>
          </div>}
          
          {order.extras.print_receipt && <div>
            <h3 className="mt4">{translate( "Belegausdruck/Innendienst" )}</h3>
            <p>{order.extras.print_receipt}</p>
          </div>}
          
          {/*!order.extras.payment && <div className="mt4">
            <p className="b"> {translate( "confirmation.notice" )}</p>
            <p>Der Gesamtpreis netto kann sich bei der Rechnungsstellung durch Rabatte noch ändern.</p>
          </div>*/}
        </section>
        
        {shop.config.checkout_thank_you && <div className="pv4">
          <div style={{ whiteSpace: "pre-line" }}>{window.translate( "checkout_thank_you" )}</div>
        </div>}
        <section className="text-left pt3 tc">
          <Link to="/return"> <Button className="primaryButtonSuccess" primary style={{color: "#337ab7"}}> <Icon name="chevron left"/>{translate( "zurück zur Abholerfassung" )}</Button> </Link>
        </section>
        <br/>
      </div>
      </Responsive>
    </Fragment>

  )
}




// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/returnCheckout/ReturnPageSuccess.js